
<div class="card-details-fields">
  <select-input
    id="category"
    v-model="card.category"
    label="*Category"
    searchable
    :options="categoryOptions"
    :disabled="disabled"
  />

  <text-input
    id="year"
    v-model.trim="card.year"
    label="*Year"
    placeholder="2018"
    maxlength="10"
    required
    :disabled="disabled"
  />

  <text-input
    id="set"
    v-model.trim="card.set"
    label="*Set"
    placeholder="Prizm"
    maxlength="64"
    required
    :disabled="disabled"
  />

  <text-input
    id="player"
    v-model.trim="card.player"
    label="*Player"
    placeholder="Luka Doncic"
    maxlength="64"
    required
    :options="playerOptions"
    :loading="loadingPlayers"
    :disabled="disabled"
    @input="loadPlayers"
  />

  <text-input
    id="number"
    v-model.trim="card.number"
    label="Number"
    placeholder="280"
    maxlength="12"
    :disabled="disabled"
  />

  <text-input
    id="variation"
    v-model.trim="card.variation"
    label="Variation"
    placeholder="Silver Prizm"
    maxlength="64"
    :disabled="disabled"
  />

  <select-input
    v-if="!card.cert"
    id="condition"
    v-model="card.condition"
    label="*Condition"
    searchable
    :options="conditionOptions"
    :disabled="disabled"
  />
</div>
